import { http } from '../../config/axios'

export interface ChaveDuploFatorResponse {
  // imagem do QR Code (data URI ou base64 puro) retornada pelo backend
  qrCode?: string
  // chave/segredo para inclusão manual no app autenticador
  chaveSecreta?: string
  // url otpauth:// (caso o backend retorne para gerar o QR no front)
  otpauthUrl?: string
  // true quando o backend responde 204 (duplo fator já configurado)
  jaConfigurado?: boolean
}

const getUserChaveDuploFator = (): Promise<ChaveDuploFatorResponse> => {
  return http
    .get('api/user/chave-duplo-fator')
    .then((res) => {
      // 204 No Content => duplo fator já está configurado para o usuário
      if (res.status === 204) {
        return { jaConfigurado: true }
      }
      return res.data as ChaveDuploFatorResponse
    })
    .catch((error) => {
      console.error('Erro getUserChaveDuploFator', error)
      throw Error(error.response?.data)
    })
}

export default getUserChaveDuploFator
